import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { FONT_WEIGHT_MEDIUM, gray_1, gray_3 } from '../../../styles/rn';
export default CustomStyleSheet({
  container: {
    flexDirection: 'row',
    width: 236,
    padding: 12,
    backgroundColor: '#fff',
    borderRadius: 6
  },
  image: {
    width: 32,
    height: 32
  },
  info: {
    flex: 1,
    marginLeft: 12
  },
  priceContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 2
  },
  price: _objectSpread(_objectSpread({
    maxWidth: 110,
    fontSize: 16,
    lineHeight: 20
  }, FONT_WEIGHT_MEDIUM), {}, {
    color: gray_1
  }),
  status: {
    fontSize: 12,
    lineHeight: 14
  },
  statusCompleted: {
    color: 'rgba(48, 181, 102, 1)'
  },
  statusFailed: {
    color: 'rgba(238, 44, 74, 1)'
  },
  statusPending: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  statusRefunded: {
    color: 'rgba(238, 44, 74, 1)'
  },
  statusCancelled: {
    color: 'rgba(238, 44, 74, 1)'
  },
  title: {
    fontSize: 12,
    lineHeight: 14,
    color: gray_3
  },
  description: {
    marginTop: 12,
    fontSize: 12,
    lineHeight: 14,
    color: gray_3
  },
  // vertical list item style
  itemContainer: {
    width: 286,
    alignItems: 'center'
  },
  itemImage: {
    width: 40,
    height: 40
  },
  itemInfo: {
    marginRight: 2
  },
  itemTitle: {
    fontSize: 14,
    lineHeight: 16,
    color: gray_1
  },
  itemDescription: {
    marginTop: 8
  },
  itemPriceContainer: {
    marginLeft: 'auto'
  },
  itemPrice: {
    maxWidth: 110,
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '500',
    color: gray_1,
    textAlign: 'right'
  },
  itemStatus: {
    marginTop: 8,
    textAlign: 'right'
  },
  itemArrow: {
    width: 4.5,
    height: 8,
    marginLeft: 7.74,
    marginRight: 3
  }
});